import React from 'react';
import {  CircularProgress } from '@material-ui/core';

const Loader: React.FC<any> = (params: any) => {
  return (<div style={{width:"100%", display:"flex", justifyContent:"center", marginTop:"10px"}}> 
            <CircularProgress disableShrink /> 
          </div>);
};

export default Loader;